import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contract_accessorial_charges_template_lines_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { templateId?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, OperationCodeId?: number, OperationCode?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_accessorial_charges_template_lines_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { templateId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, OperationCodeId?: number, OperationCode?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_accessorial_charges_template_lines_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { templateId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingAccessorialChargeTemplateId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, OperationCodeId?: number, OperationCode?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_accessorial_charges_template_lines_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
